import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';

const styles = {
  wrapper: {
    padding: 15
  },
};

class ScoreByDeviceTagChart extends Component {

  render() {

    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const scoreByDeviceTag = answersReport ? answersReport.scoreByDeviceTag : [];

    let { tagsToShow } = this.props;
    tagsToShow = tagsToShow || [];
    const categories = (scoreByDeviceTag || []).filter(item => tagsToShow.length ? tagsToShow.indexOf(item.tag) !== -1 : true).map(item => item.tag);
    const data = (scoreByDeviceTag || []).filter(item => tagsToShow.length ? tagsToShow.indexOf(item.tag) !== -1 : true).map(item => item.score);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
      },
      title: {
        text: intl.formatMessage({id: 'score'}),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: scoreByDeviceTag[index].count,
          });
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y:.1f}',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(ScoreByDeviceTagChart),
  graphql`
    fragment ScoreByDeviceTagChart_answersReport on AnswersReport {
      scoreByDeviceTag {
        tag
        score
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/ScoreByDeviceTagChart/ScoreByDeviceTagChart.js